import { render, staticRenderFns } from "./EditProfile.html?vue&type=template&id=ef05c2a0&scoped=true&external"
import script from "./EditProfile.vue?vue&type=script&lang=js"
export * from "./EditProfile.vue?vue&type=script&lang=js"
import style0 from "./EditProfile.scss?vue&type=style&index=0&id=ef05c2a0&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef05c2a0",
  null
  
)

export default component.exports